import { colors } from '@styles/colors'
import { border, borderRadius } from '@styles/utils'
import { padding } from 'polished'
import { useStyletron } from 'styletron-react'
import { BaseBlock } from '../base-block'
import { Icon, IconType } from '../icon'

interface InfobookWithIconProps {
  children: React.ReactNode
  icon: IconType
}

export const InfoBoxWithIcon = ({ children, icon }: InfobookWithIconProps) => {
  const [css] = useStyletron()

  return (
    <BaseBlock
      className={css({
        width: '100%',
        ...padding('20px'),
        ...borderRadius(16),
        ...border(colors.gray200),
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
      })}
    >
      <Icon type={icon} size={32} color={colors.gray700} />
      <BaseBlock marginTop="12px">{children}</BaseBlock>
    </BaseBlock>
  )
}
